import css, {SystemCssProperties, SystemStyleObject} from '@styled-system/css'
import {ThemeColorPaths, ThemeShadowPaths} from './theme'
import {ColorProps, ShadowProps} from 'styled-system'
import merge from 'deepmerge'

export type FuegoCssProperties = {
  [K in keyof SystemCssProperties]: K extends keyof ColorProps
    ? ThemeColorPaths | SystemCssProperties[K]
    : K extends keyof ShadowProps
    ? ThemeShadowPaths | SystemCssProperties[K]
    : SystemCssProperties[K]
}

export type FuegoSystemStyleObject = FuegoCssProperties | SystemStyleObject

export interface SxProp {
  /**
   * The sx prop allows ad-hoc styling that is theme aware
   *
   * It is used by UI libraries to allow users to apply inline styles to a component
   * while still ensuring that the component is theme-aware.
   *
   * See https://fuegokit.design/react/getting-started/sx-prop
   */
  sx?: FuegoSystemStyleObject
}

const sx = (props: SxProp) => css(props.sx)

export default sx
export {merge}
